import { render, staticRenderFns } from "./ItemCategory.vue?vue&type=template&id=7c5fbd34&"
import script from "./ItemCategory.vue?vue&type=script&lang=js&"
export * from "./ItemCategory.vue?vue&type=script&lang=js&"
import style0 from "./ItemCategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports